export default __webpack_public_path__ + "static/media/no-record.97f50720.svg";